/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rental_Your_BookingInputs */

const en_rental_your_booking = /** @type {(inputs: Rental_Your_BookingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your Booking`)
};

const es_rental_your_booking = /** @type {(inputs: Rental_Your_BookingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tu Reserva`)
};

const fr_rental_your_booking = /** @type {(inputs: Rental_Your_BookingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Votre réservation`)
};

const de_rental_your_booking = /** @type {(inputs: Rental_Your_BookingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deine Buchung`)
};

const id_rental_your_booking = /** @type {(inputs: Rental_Your_BookingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pemesanan Anda`)
};

/** @type {(inputs: Rental_Your_BookingInputs) => LocalizedString} */
const ja_rental_your_booking = en_rental_your_booking;

/** @type {(inputs: Rental_Your_BookingInputs) => LocalizedString} */
const zh_rental_your_booking = en_rental_your_booking;

/** @type {(inputs: Rental_Your_BookingInputs) => LocalizedString} */
const ar_rental_your_booking = en_rental_your_booking;

/** @type {(inputs: Rental_Your_BookingInputs) => LocalizedString} */
const it_rental_your_booking = en_rental_your_booking;

/** @type {(inputs: Rental_Your_BookingInputs) => LocalizedString} */
const ru_rental_your_booking = en_rental_your_booking;

/** @type {(inputs: Rental_Your_BookingInputs) => LocalizedString} */
const pt_rental_your_booking = en_rental_your_booking;

/** @type {(inputs: Rental_Your_BookingInputs) => LocalizedString} */
const ko_rental_your_booking = en_rental_your_booking;

/**
* | output |
* | --- |
* | "Your Booking" |
*
* @param {Rental_Your_BookingInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const rental_your_booking = /** @type {((inputs?: Rental_Your_BookingInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rental_Your_BookingInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_rental_your_booking(inputs)
	if (locale === "es") return es_rental_your_booking(inputs)
	if (locale === "fr") return fr_rental_your_booking(inputs)
	if (locale === "de") return de_rental_your_booking(inputs)
	if (locale === "ja") return ja_rental_your_booking(inputs)
	if (locale === "zh") return zh_rental_your_booking(inputs)
	if (locale === "ar") return ar_rental_your_booking(inputs)
	if (locale === "id") return id_rental_your_booking(inputs)
	if (locale === "it") return it_rental_your_booking(inputs)
	if (locale === "ru") return ru_rental_your_booking(inputs)
	if (locale === "pt") return pt_rental_your_booking(inputs)
	return ko_rental_your_booking(inputs)
});